import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { FormattedMessage } from 'react-intl';
import style from './style.module.less';

export const AlertsGridButtons = ({ selectedAlertIds, onAlertDismissal, errorOccurred }) => {
  return (
    <div className={style['alerts-grid-buttons']}>
      <Button disabled={selectedAlertIds.length === 0} onClick={onAlertDismissal} theme={THEME_CONSTANTS.tertiary}>
        <FormattedMessage
          defaultMessage='Dismiss {selectedAlertIdsCount, plural, one {# Alert} other {# Alerts}}'
          description='alertsGridButtons.dismissSelected'
          id='vIrPM8'
          values={{ selectedAlertIdsCount: selectedAlertIds.length }}
        />
      </Button>
      <div>
        {errorOccurred && (
          <div className={style['alerts-error']}>
            <FormattedMessage
              defaultMessage='An error occurred while fetching the alerts.'
              description='alertsGridButtons.errorOccurred'
              id='MY43jK'
            />
          </div>
        )}
      </div>
    </div>
  );
};

AlertsGridButtons.propTypes = {
  selectedAlertIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAlertDismissal: PropTypes.func.isRequired,
  errorOccurred: PropTypes.bool.isRequired,
};
